import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M13 7 9 3 5 7l4 4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m17 11 4 4-4 4-4-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m8 12 4 4 6-6-4-4Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m16 8 3-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 21a6 6 0 0 0-6-6", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Satellite";
const Satellite = memo(themed(Icon));
export {
  Satellite
};
//# sourceMappingURL=satellite.js.map
